import useLocalStorageObj from "./useLocalStorageObj";

export default function useControlBarStorage() {
  const ops = useLocalStorageObj('controlBar', {pageKey: 'LOGIN'});
  return {
    controlBar: ops.getObj,
    setControlBar: ops.setObj
  }
}
